<!--
 * @Description: 合并线索组件
 * @Author: mdb
 * @Date: 2022-07-13 17:35:13
 * @LastEditTime: 2022-11-07 15:45:42
 * @LastEditors: cxh
-->
<template>
  <CosModal
    v-model:visible="visible"
    title="线索合并后数据将不能恢复，请谨慎操作！"
    width="750px"
    :bodyStyle="{ 'max-height': 'calc(100vh - 300px)', 'overflow-y': 'auto' }"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-alert
      message="合并后，只保留选择的线索，删除其他的线索；原线索中不重复的联系人均会合并到新线索下。"
      type="warning"
      show-icon
    />
    <ul class="list">
      <li v-for="(item, index) in optionsEnum" :key="index">
        <div class="flex1 content">
          <p>待合并线索：</p>
          <p class="name" :title="item.label">{{ item.label }}</p>
        </div>
        <div class="flex1 content">
          <p>ID：</p>
          <p class="name">{{ item.value }}</p>
        </div>
      </li>
    </ul>
    <a-form :wrapper-col="{ span: 24 }">
      <a-form-item label="合并于主线索" v-bind="validateInfos.targetClueId">
        <a-select v-model:value="dataForm.targetClueId" placeholder="请选择" allowClear>
          <a-select-option v-for="item in optionsEnum" :key="item.value" :value="item.value">{{
            `${item.label}(${item.value})`
          }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </CosModal>
</template>

<script setup lang="ts">
import { reactive, ref, computed } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { salesClueMarge } from '@/api/gucangSales/clueManage'
import type { SalesClueListItem } from '@/typings/api/clueManage'

const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ targetClueId: string; originalIdList: any[] }>({ targetClueId: '', originalIdList: [] })
const formRules = reactive({
  targetClueId: [{ required: true, message: '请指定主线索' }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const optionsEnum = computed(() => {
  return selectedData.value.map((item) => ({
    label: item.customerName,
    value: item.clueId
  }))
})
const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['fetch'])
const handleOk = () => {
  validate().then(() => {
    loading.value = true
    const list = selectedData.value.filter((item) => item.clueId !== dataForm.targetClueId)
    dataForm.originalIdList = list.map((item: SalesClueListItem) => item.clueId)
    const params = Object.assign({}, dataForm)
    salesClueMarge(params)
      .then(() => {
        DcMessage.success('合并线索成功')
        resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'ClueMarge' }
</script>

<style lang="scss" scoped>
.list {
  margin: 20px 0;

  li {
    display: flex;
    margin-bottom: 9px;
    .content {
      display: flex;
      align-items: center;
    }
  }
  .name {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 210px;
    padding: 0;
  }
}
.flex1 {
  flex: 1;
}
</style>
